export const isHRS = window.location.origin.includes("hrsolutions");